import http from '@/assets/js/interceptor';

/**
 * 获取列表数据
 * @param {Object} filter 查询字段
 * @returns
 */
export function getTableData (filter) {
  return http.post('/v1/orgUserAuth/list', filter);
}

/**
 * 获取部门数据
 * @returns
 */
export function getDepartmentData() {
  return http.get('/v1/departments/flatTreeOrgan', { domainType: 'orgApi', noUseGlobalLoading: true });
}

/**
 * 根据角色的可用的部门获取部门数的数据
 * @returns
 */
export function getDepartmentDataByOperableDepart(relationIds) {
  return http.get(`/v1/departments/parentAll/${relationIds}`, { domainType: 'orgApi', noUseGlobalLoading: true });
}

/**
 * 获取用户权限分配的限制应用列表
 * @param data {object}
 * @param data.userId {string} 用户id
 * @returns {AxiosPromise<any>}
 */
export function getAppInAuthUserList (data) {
  return http.post('/v1/orgUserAuth/appInAuthUserList', data);
}

/**
 * 编辑用户权限分配的限制应用
 * @param data {object}
 * @param data.appIdList {array} 应用id列表
 * @param data.userId {string} 用户id
 * @returns {AxiosPromise<any>}
 */
export function saveAppInAuthUser (data) {
  return http.post('/v1/orgUserAuth/editAppInAuthUser', data);
}

export const getOrgUseAppRowRuleApi = (data) => {
  return http.post('/v1/orgUserAuth/orgUseAppRowRule', data);
};

/**
 * 提交角色数据列权限，全局
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const submitOrgUseAppRowRuleApi = (data) => {
  return http.post('/v1/orgUserAuth/editOrgUseAppRowRule', data);
};

/**
 * 获取当前用户拥有的分配应用列表
 * @returns {AxiosPromise<any>}
 */
export const getOwnAppInAuthUserListApi = () => {
  return http.post('/v1/orgUserAuth/ownAppInAuthUserList');
};

/**
 * 获取角色下 app 通过数据进行权限的是全部信息
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const getRoleAppRowRuleAPi = (data) => {
  return http.post('/v1/orgUserAuth/orgUserRoleAppRowRule', data);
};

/**
 * 角色下 数据权限提交
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const submitOrgUserRoleApi = (data) => {
  return http.post('/v1/orgUserAuth/editOrgUserRoleAppRowRule', data);
};
